import {
  SupplyIntelCategoryRowSchema,
  SupplyIntelCategorySortKey,
} from "@redotech/redo-inventory-common/supply-intel/brand-categories";
import {
  SupplyIntelUnitTotalsSchema,
  SupplyIntelWarehouseSchema,
} from "@redotech/redo-inventory-common/supply-intel/brand-list";
import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { createTableSortSchema } from "@redotech/redo-views-common/table";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/** Returned units on Redo's shelves, one row per product category across brands, from the cached snapshot. */
export const getSupplyIntelCategories = unaryRpc({
  name: "getSupplyIntelCategories" as const,
  input: z.object({
    search: z.string().optional(),
    /** Only warehouse filters apply; the brand list's other filters describe brands. */
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
    sort: createTableSortSchema(z.enum(SupplyIntelCategorySortKey)).optional(),
    page: z.number().int().min(0).default(0),
    pageSize: z.number().int().min(1).max(500).default(50),
  }),
  output: z.object({
    /** Null until the first snapshot is built. */
    page: z
      .object({
        rows: z.array(SupplyIntelCategoryRowSchema),
        totalCount: z.number(),
        /** Totals over every brand in the selected warehouses. */
        summary: SupplyIntelUnitTotalsSchema,
        currencies: z.array(z.string()),
        warehouses: z.array(SupplyIntelWarehouseSchema),
        dataAsOf: z.date(),
        configVersion: z.string(),
        truncated: z.boolean(),
      })
      .nullable(),
    buildStartedAt: z.date().nullable(),
  }),
});
